export default __webpack_public_path__ + "static/media/left.1f17a882.svg";